import { type JSX } from 'react';

interface SSOPromptProps {
    ssoError: string | null;
    isRedirectingToSSO: boolean;
    disabled?: boolean;
    onContinue: () => void;
    onFallbackToPassword: () => void;
}

export function SSOPrompt({
    ssoError,
    isRedirectingToSSO,
    disabled = false,
    onContinue,
    onFallbackToPassword,
}: SSOPromptProps): JSX.Element {
    return (
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded">
            <p className="text-sm text-gray-800 mb-4">
                Your organization uses single sign-on. Click continue to login with your organization&apos;s identity
                provider.
            </p>

            {ssoError && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded">
                    <p className="text-sm text-red-800">{ssoError}</p>
                    <button
                        type="button"
                        onClick={onFallbackToPassword}
                        className="mt-2 text-sm text-red-700 hover:text-red-900 underline"
                    >
                        Use password login instead
                    </button>
                </div>
            )}

            <button
                type="button"
                onClick={onContinue}
                disabled={disabled || isRedirectingToSSO}
                className={`w-full py-3 px-4 rounded font-medium transition-colors ${
                    disabled || isRedirectingToSSO
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer'
                }`}
            >
                {isRedirectingToSSO ? 'Redirecting...' : 'Continue with SSO'}
            </button>
        </div>
    );
}
